<template lang="pug">
.modal-backdrop(v-if='visible')
  .modal-container
    .info-first 享受 出行专享券 等6大权益
    .info-title 确定放弃省钱机会吗
    .info-word
      span 一单回本 每月帮你省
      span.red-font {{save || '-'}}
      span 元
    .business-block
      .business-list
        .business-list-item(v-for="(item,index) in commonBonus")
          .business-img
            img.business-top-img(:src="item.bonusEntity.icon")
          .business-title {{item.bonusEntity.mainTitle}}
          .business-word {{item.bonusEntity.subTitle}}
    .footer
      .cancel(@click='cancel') 去意已决
      .confirm(@click='close') 再看看
  .modal-close(@click='close')
</template>

<script>
import { UBT } from '@hb/tianqi/lib/ubt.h5';
import { getSource } from '../../../../utils';

export default {
  props: {
    save: {
      type: String,
      default: '-',
    },
    transType: {
      type: Number,
      required: true,
    },
    transPrice: {
      type: [Number, String],
      required: true,
    },
    commonBonus: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      param: {}, // close时发送
    };
  },
  created() {
    UBT.moduleExpose({
      pageId: 'platform_savemoneycard_page',
      categoryId: 'platform',
      moduleId: 'platform_opencard_stayopencard_popup',
      contentId: 'platform_opencard_stayopencard_popup',
      exposureTimes: 1,
      businessInfo: {
        adsource: getSource(),
      },
    });
  },
  methods: {
    open(options, param = {}) {
      UBT.clickButton({
        pageId: 'platform_savemoneycard_page',
        buttonName: 'platform_opencard_stayopencard_popup',
        categoryId: 'platform',
        businessInfo: {
          adsource: getSource(),
        },
      });
      this.visible = true;
      this.param = param;
    },
    cancel() {
      this.visible = false;
      this.$emit('cancel', this.param);
    },
    close() {
      this.visible = false;
      this.$emit('close', this.param);
    },
    confirm() {
      this.$emit('confirm', this.param, this.transType, this.transPrice);
      this.visible = false;
    },
  },
};
</script>

<style lang="less" scoped>
.modal-backdrop {
  position: fixed;
  z-index: 900;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
}

.modal-container {
  margin: 2.15rem auto;
  width: 3.2rem;
  height: 3.2rem;
  background: url(https://m.hellobike.com/resource/helloyun/08345/6fFoCQMrPs.png?x-oss-process=image/quality,q_80);
  background-size: 100% 100%;
  border-radius: 0.12rem;
  position: relative;
  padding-bottom: 0.2rem;

  .info-first {
    font-size: 0.12rem;
    font-family: AlibabaPuHuiTi-Regular, AlibabaPuHuiTi, sans-serif;
    font-weight: 400;
    color: rgba(68, 29, 6, 0.8);
    padding-top: 0.36rem;
    padding-left: 0.37rem;
  }

  .info-title {
    font-size: 0.18rem;
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    line-height: 0.25rem;
    color: #441d06;
    text-align: center;
    padding-top: 0.34rem;
  }

  .info-word {
    font-size: 0.14rem;
    font-family: PingFangSC-Regular, PingFang SC, sans-serif;
    font-weight: 400;
    color: #441d06;
    margin: 0.05rem auto;
    text-align: center;

    .red-font {
      font-size: 18px;
      font-family: DINAlternate-Bold, DINAlternate, sans-serif;
      font-weight: bold;
      color: #fa4614;
    }
  }

  .business-list {
    margin-top: 0.21rem;
    padding-left: 0.16rem;
    height: 0.77rem;
    display: flex;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
      color: transparent;
    }

    .business-list-item {
      width: 0.88rem;
      flex: 1;
      margin-right: 0.18rem;

      .business-img {
        display: flex;
        width: 0.68rem;

        img.business-top-img {
          margin: 0 auto;
          width: 0.46rem;
          height: 0.46rem;
        }
      }

      .business-title {
        text-align: center;
        margin-top: -0.02rem;
        font-size: 0.12rem;
        font-family: PingFangSC-Semibold, PingFang SC, sans-serif;
        font-weight: 600;
        color: #6f2500;
        opacity: 0.8;
      }

      .business-word {
        text-align: center;
        transform: scale(0.833);
        font-size: 0.12rem;
        font-family: PingFangSC-Regular, PingFang SC, sans-serif;
        font-weight: 400;
        color: rgba(165, 71, 0, 0.65);
        margin-top: -0.01rem;
      }
    }
  }

  .footer {
    margin-top: 0.27rem;
    padding: 0 0.13rem 0 0.19rem;
    display: flex;

    .cancel {
      width: 1.4rem;
      height: 0.4rem;
      background: #f0f3f5;
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: 400;
      color: #5a6066;
      line-height: 0.4rem;
      text-align: center;
      margin-right: 0.08rem;
    }

    .confirm {
      width: 1.4rem;
      height: 0.4rem;
      background: linear-gradient(90deg, #fa8621 0%, #fa3a00 100%);
      box-shadow: 0 0.01rem 0.08rem 0 rgba(250, 87, 13, 0.3);
      border-radius: 0.08rem;
      font-size: 0.18rem;
      font-weight: 500;
      color: #fff;
      line-height: 0.4rem;
      text-align: center;
      position: relative;

      .confirm-toast {
        top: -0.22rem;
        right: 0.2rem;
        width: 0.86rem;
        height: 0.34rem;
        position: absolute;

        img {
          width: 0.86rem;
          height: 0.34rem;
        }
      }
    }
  }
}

.modal-close {
  margin: -1.8rem auto;
  background: url(https://m.hellobike.com/resource/helloyun/08345/3fkTG3TrVs.png?x-oss-process=image/quality,q_80) no-repeat;
  background-size: 100%;
  width: 0.32rem;
  height: 0.32rem;
}
</style>
